module.exports = __webpack_public_path__ + "static/img/11.23ae92cc.png";